import { metaMask, metaMaskHooks, walletConnect, walletConnectHooks } from '@app/services'
import { Web3ReactHooks, Web3ReactProvider } from '@web3-react/core'
import { MetaMask } from '@web3-react/metamask'
import { WalletConnect } from '@web3-react/walletconnect-v2'
import { Lock } from 'collections/lock'
import Head from 'next/head'

const connectors: [MetaMask | WalletConnect, Web3ReactHooks][] = [
  [metaMask, metaMaskHooks],
  [walletConnect, walletConnectHooks],
]

export default function LockPage() {
  return (
    <>
      <Head>
        <title>Fees - Coast</title>
      </Head>
      <Web3ReactProvider connectors={connectors}>
        <Lock isForDrawer={false} />
      </Web3ReactProvider>
    </>
  )
}
